import { MnoConfig } from '../types';
import { mtnNigeriaConfig } from './mtn-nigeria';
import { mtnSouthAfricaConfig } from './mtn-south-africa';
import { mtnGhanaConfig } from './mtn-ghana';
import { localhostConfig } from './localhost';
import { stagingConfig } from './staging';
import { devConfig } from './dev';
import { preprodConfig } from './preprod';
import { staging2Config } from './staging2';

/**
 * Hostname to MNO Config mapping
 * Maps full hostnames directly to MNO configurations
 */
const hostnameToMnoConfigMap: Record<string, MnoConfig> = {
  'mtn.ng.life.fun': mtnNigeriaConfig,
  'mtn.za.life.fun': mtnSouthAfricaConfig,
  'mtn.gh.life.fun': mtnGhanaConfig,
  'berd1.life.fun': preprodConfig,
  'life-frontend.1pin.com': devConfig,
  'life-frontend-staging.1pin.com': stagingConfig,
  'life-frontend-staging2.1pin.com': staging2Config,
  'localhost': localhostConfig,
};

/**
 * Get MNO configuration based on current hostname (client-side only)
 * Automatically extracts from window.location.hostname
 * Falls back to localhost config if hostname not found
 */
export function getMnoConfig(): MnoConfig {
  if (typeof window === 'undefined') {
    return localhostConfig; // SSR fallback
  }
  
  const hostname = window.location.hostname.toLowerCase();
  const config = hostnameToMnoConfigMap[hostname];
  return config || localhostConfig;
}

export { mtnNigeriaConfig, mtnSouthAfricaConfig, mtnGhanaConfig, localhostConfig, stagingConfig, staging2Config, devConfig, preprodConfig };

